import { MessageCircle } from "lucide-react";
import { waLink } from "@/components/ui-kit";

export const WhatsAppButton = () => (
  <a
    href={waLink()}
    target="_blank"
    rel="noreferrer"
    data-testid="whatsapp-sticky-button"
    aria-label="Scrivici su WhatsApp"
    className="fixed bottom-6 right-6 z-50 group flex items-center gap-3 bg-[#25D366] text-white pl-4 pr-5 py-3.5 rounded-full shadow-[0_10px_40px_-8px_rgba(37,211,102,0.7)] hover:scale-105 transition-transform duration-300"
  >
    <MessageCircle size={22} className="shrink-0" />
    <span className="hidden sm:block text-sm font-semibold max-w-0 group-hover:max-w-[140px] overflow-hidden whitespace-nowrap transition-all duration-500">
      Scrivici su WhatsApp
    </span>
  </a>
);
